// Ad-network wiring (Vibe or any provider). Everything is env-driven so live snippets
// drop in without code changes. Until REACT_APP_AD_SCRIPT_SRC is set, AdSlot renders a
// CLS-safe house placeholder (no revenue, no layout shift, no broken scripts).
//
// To go live, set in frontend/.env and restart the frontend:
//   REACT_APP_AD_SCRIPT_SRC   = https://cdn.vibe.co/loader.js   (your Vibe loader URL)
//   REACT_APP_AD_SLOT_LEADERBOARD = <vibe slot id for 728x90>
//   REACT_APP_AD_SLOT_RECTANGLE   = <vibe slot id for 300x250>
//   REACT_APP_AD_SLOT_NATIVE      = <vibe slot id for in-feed native>
export const AD_SCRIPT_SRC = process.env.REACT_APP_AD_SCRIPT_SRC || "";

export const AD_SLOTS = {
  leaderboard: process.env.REACT_APP_AD_SLOT_LEADERBOARD || "",
  rectangle: process.env.REACT_APP_AD_SLOT_RECTANGLE || "",
  native_card: process.env.REACT_APP_AD_SLOT_NATIVE || "",
};

// Ads only activate once a loader script URL is configured.
export const ADS_ENABLED = !!AD_SCRIPT_SRC;

// Injects the network loader <script> exactly once, then resolves.
let scriptPromise = null;
export const loadAdScript = () => {
  if (!AD_SCRIPT_SRC) return Promise.resolve(false);
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve) => {
    const existing = document.getElementById("rv-ad-loader");
    if (existing) return resolve(true);
    const s = document.createElement("script");
    s.id = "rv-ad-loader";
    s.async = true;
    s.src = AD_SCRIPT_SRC;
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.head.appendChild(s);
  });
  return scriptPromise;
};
